import { useQuery } from '@tanstack/react-query'
import { getWorkflowSuppliers } from '@/services/api'

export const workflowSuppliersQueryKey = (workflowId: string) =>
  ['workflow-suppliers', workflowId] as const

export const workflowSuppliersQueryOptions = {
  staleTime: 60 * 1000,
} as const

export function useWorkflowSuppliers(workflowId: string | undefined) {
  return useQuery({
    queryKey: workflowSuppliersQueryKey(workflowId ?? ''),
    queryFn: () => getWorkflowSuppliers(workflowId!),
    enabled: !!workflowId,
    ...workflowSuppliersQueryOptions,
  })
}
